import { autoinject } from 'aurelia-framework';
import { NetlogHttpClient } from 'lib/http';
import { UpdateServiceQueuePipelineContentDto } from 'models/service/ServiceQueue';

@autoinject
export class ServiceQueueService {
  private readonly BASE_URL = 'api/service-queues';

  constructor(private client: NetlogHttpClient) {}

  async updateServiceQueuePipelineContent(pipelineId: number, data: UpdateServiceQueuePipelineContentDto) {
    return await this.client.patch({
      url: `${this.BASE_URL}/pipelines/${pipelineId}/content`,
      data,
    });
  }
}
